import React, { useContext as useContextCore } from 'react'
import { SSRProvider } from 'react-bootstrap'
export type ProviderProps = {
  routeContext?: Record<string, any>
  children: React.ReactNode
}

export type ContextType = Omit<ProviderProps, 'children'>

const context = React.createContext<ContextType>({} as ContextType)
const CoreProvider = context.Provider

export const AppProvider = ({ children, routeContext, ...props }: ProviderProps) => {
  routeContext = routeContext ?? {}

  return (
    <CoreProvider value={{ ...props, routeContext }}>
      <SSRProvider>{children}</SSRProvider>
    </CoreProvider>
  )
}

export const useAppContext = () => useContextCore(context)
